import React, { useEffect, useState } from 'react';
import ProfileNavBar from './ProfileNavBar';
import Footer from './Footer';
import '../css/LogsDashboard.css';
import UserFooter from './UserFooter';
import ChatComponent from './ChatComponent';

const LogsDashboard = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [groupedLogs, setGroupedLogs] = useState({});
    const [editModeGroup, setEditModeGroup] = useState({});
    const [editedLogs, setEditedLogs] = useState({});

    useEffect(() => {
        const fetchLogs = async () => {
            const [activityRes, customRes] = await Promise.all([
                fetch('https://18.117.231.157/api/getUserActivities', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID: user.userID }),
                }),
                fetch('https://18.117.231.157/api/getUserAddedActivities', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID: user.userID }),
                }),
            ]);

            const activityData = await activityRes.json();
            const customData = await customRes.json();

            const combined = [
                ...(activityData.activities || []).map(log => ({ ...log, type: 'activityLog' })),
                ...(customData.activities || []).map(log => ({ ...log, type: 'userAddedActivity' })),
            ];

            const grouped = groupByDate(combined);
            setGroupedLogs(grouped);
        };

        fetchLogs();
    }, [user.userID]);

    const fetchLogs = async () => {
        const [activityRes, customRes] = await Promise.all([
            fetch('https://18.117.231.157/api/getUserActivities', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID: user.userID }),
            }),
            fetch('https://18.117.231.157/api/getUserAddedActivities', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userID: user.userID }),
            }),
        ]);

        const activityData = await activityRes.json();
        const customData = await customRes.json();

        const combined = [
            ...(activityData.activities || []).map(log => ({ ...log, type: 'activityLog' })),
            ...(customData.activities || []).map(log => ({ ...log, type: 'userAddedActivity' })),
        ];

        const grouped = groupByDate(combined);
        setGroupedLogs(grouped);
    };

    const groupByDate = (logsArray) => {
        const grouped = {};
        logsArray
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .forEach(log => {
                const key = new Date(log.createdAt).toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                if (!grouped[key]) grouped[key] = [];
                grouped[key].push(log);
            });
        return grouped;
    };

    const handleEditGroup = (groupKey) => {
        setEditModeGroup(prev => ({ ...prev, [groupKey]: true }));

        const groupLogs = groupedLogs[groupKey];
        const updatedEdits = {};

        groupLogs.forEach(log => {
            if (log.type === 'activityLog') {
                updatedEdits[log.id] = {
                    id: log.id,
                    sleep: log.sleep ?? '',
                    workout: log.workout ?? '',
                    walking: log.walking ?? '',
                    cycling: log.cycling ?? '',
                    running: log.running ?? '',
                    yoga: log.yoga ?? '',
                    meditation: log.meditation ?? '',
                    swimming: log.swimming ?? '',
                };
            } else {
                updatedEdits[log.id] = {
                    id: log.id,
                    activityName: log.activityName ?? '',
                    description: log.description ?? '',
                    unit: log.unit ?? '',
                    value: log.value ?? '',
                };
            }
        });

        setEditedLogs(updatedEdits);
    };

    const handleInputChange = (logId, field, value) => {
        setEditedLogs(prev => ({
            ...prev,
            [logId]: {
                ...prev[logId],
                [field]: value
            }
        }));
    };

    const handleSaveGroup = async (groupKey) => {
        const groupLogs = groupedLogs[groupKey];

        for (const log of groupLogs) {
            const updated = editedLogs[log.id];
            if (!updated) continue;

            const endpoint = log.type === 'activityLog'
                ? 'https://18.117.231.157/api/updateActivityLog'
                : 'https://18.117.231.157/api/updateUserAddedActivity';

            const res = await fetch(endpoint, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updated),
            });

            const data = await res.json();
            if (!data.success) {
                alert('Failed to update a log.');
                return;
            }
        }

        alert('All logs updated!');
        setEditModeGroup(prev => ({ ...prev, [groupKey]: false }));
        fetchLogs(); // Refresh logs after saving
    };

    const handleCancelEdit = (groupKey) => {
        setEditModeGroup(prev => ({ ...prev, [groupKey]: false }));
        setEditedLogs({});
    };

    const handleDeleteGroup = async (groupKey) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete all logs from: ${groupKey}?`);
        if (!confirmDelete) return;

        const logsToDelete = groupedLogs[groupKey];

        for (const log of logsToDelete) {
            const endpoint = log.type === 'activityLog'
                ? 'https://18.117.231.157/api/deleteActivityLog'
                : 'https://18.117.231.157/api/deleteUserAddedActivity';

            const res = await fetch(endpoint, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: log.id }),
            });

            const data = await res.json();
            if (!data.success) {
                alert('Failed to delete one of the logs.');
                return;
            }
        }

        alert('Logs deleted successfully.');
        fetchLogs();
    };

    const getUnit = (field) => {
        if (field === 'sleep') return 'hours';
        if (field === 'walking') return 'steps';
        return 'minutes';
    };
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
    return (
        <div>
            <ProfileNavBar />
            <br /><br /><br /><br /><br />
            <h1 className='contactuspageheaders'>Your Activity Logs</h1>
            {Object.keys(groupedLogs).length === 0 ? (
                <div style={{ textAlign: 'center', margin: '2rem auto' }}>
                    <h3 className='contactuspageheaders'>You have not logged any activities. Click on the button below to log an activity.</h3>
                    <button
                        className="goals"
                        onClick={() => window.location.href = '/activitylogging'}
                    >
                        Log Activity
                    </button>
                </div>
            ) :
                (Object.entries(groupedLogs).map(([dateKey, logsAtTime]) => (
                    <div key={dateKey} className="logTile">
                        <h3 style={{ textAlign: 'center', marginTop: '2rem' }}>{dateKey}</h3>

                        {editModeGroup[dateKey] ? (
                            <div className='edit-log-form'>
                                {logsAtTime.map(log =>
                                    log.type === 'activityLog' ? (
                                        <div key={log.id}>
                                            <h4 style={{ textAlign: 'center' }}>Basic Activities</h4>
                                            <div className='rowtype'>
                                                {['sleep', 'workout', 'walking', 'cycling'].map(field => (
                                                    <div key={field} className='columntype' style={{ gap: '3px' }}>
                                                        <label style={{ minWidth: '90px' }}>{capitalize(field)}</label>
                                                        <input
                                                            type="number"
                                                            value={editedLogs[log.id]?.[field] ?? log[field] ?? ''}
                                                            onChange={(e) => handleInputChange(log.id, field, e.target.value)}
                                                        />
                                                        <span style={{ fontStyle: 'italic' }}>{getUnit(field)}</span>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className='rowtype'>
                                                {['running', 'yoga', 'meditation', 'swimming'].map(field => (
                                                    <div key={field} className='columntype'>
                                                        <label style={{ minWidth: '90px' }}>{capitalize(field)}</label>
                                                        <input
                                                            type="number"
                                                            value={editedLogs[log.id]?.[field] ?? log[field] ?? ''}
                                                            onChange={(e) => handleInputChange(log.id, field, e.target.value)}
                                                        />
                                                        <span style={{ fontStyle: 'italic' }}>{getUnit(field)}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div key={log.id}>
                                            <h4 style={{ textAlign: 'center' }}>Additional Activities</h4>
                                            <div className='rowtype'>
                                                <div className='columntype'>
                                                    <label>Name</label>
                                                    <input
                                                        type="text"
                                                        value={editedLogs[log.id]?.activityName ?? ''}
                                                        onChange={(e) => handleInputChange(log.id, 'activityName', e.target.value)}
                                                    />
                                                </div>
                                                <div className='columntype'>
                                                    <label>Description</label>
                                                    <input
                                                        type="text"
                                                        value={editedLogs[log.id]?.description ?? ''}
                                                        onChange={(e) => handleInputChange(log.id, 'description', e.target.value)}
                                                    />
                                                </div>
                                                <div className='columntype'>
                                                    <label>Unit</label>
                                                    <input
                                                        type="text"
                                                        value={editedLogs[log.id]?.unit ?? ''}
                                                        onChange={(e) => handleInputChange(log.id, 'unit', e.target.value)}
                                                    />
                                                </div>
                                                <div className='columntype'>
                                                    <label>Value</label>
                                                    <input
                                                        type="number"
                                                        value={editedLogs[log.id]?.value ?? ''}
                                                        onChange={(e) => handleInputChange(log.id, 'value', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                                <br></br>
                                <div className="rowtype">
                                    <button className="submitbutton" onClick={() => handleSaveGroup(dateKey)}>Save All</button>
                                    <button className="submitbutton" onClick={() => handleCancelEdit(dateKey)}>Cancel</button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {logsAtTime.map(log =>
                                    log.type === 'activityLog' ? (
                                        <div key={log.id}>
                                            <div className='columntype' style={{ gap: '3px' }}>
                                                <div className='rowtype'>
                                                    {['sleep', 'workout', 'walking', 'cycling'].map(field => (
                                                        <div key={field}>{capitalize(field)}: {log[field] != null ? log[field] : 0} {getUnit(field)}</div>
                                                    ))}
                                                </div>
                                                <div className='rowtype'>
                                                    {['running', 'yoga', 'meditation', 'swimming'].map(field => (
                                                        <div key={field}>{capitalize(field)}: {log[field] != null ? log[field] : 0} {getUnit(field)}</div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div key={log.id} className='rowtype' style={{ justifyContent: 'center' }}>
                                            <p><strong>{log.activityName}</strong> : {log.value} {log.unit}</p>
                                            <p>{log.description}</p>
                                        </div>
                                    )
                                )}
                                <br></br>
                                <div className="rowtype">
                                    <button className="submitbutton" style={{ backgroundColor: 'black' }} onClick={() => handleEditGroup(dateKey)}>Edit</button>
                                    <button className="submitbutton" style={{ backgroundColor: 'red' }} onClick={() => handleDeleteGroup(dateKey)}>Delete</button>
                                </div>
                            </div>
                        )}
                    </div>
                ))
                )}
                <br></br>
                <ChatComponent />
            <br></br>
            <UserFooter />
            <Footer />
        </div >
    );
};

export default LogsDashboard;
